var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"settings-billing"}},[_c('div',{staticClass:"d-flex flex-column justify-content-center mt-4 mt-md-0"},[_c('SettingCard',{attrs:{"type":"rows"}},[_c('template',{slot:"label"},[_vm._v(" Your Plan ")]),_c('template',{slot:"content"},[_vm._v(" "+_vm._s(_vm.appManager)+" ")])],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }